import {
  CREATE_ORGANIZATION_REQUEST,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_FAILED,
} from './actionTypes';

const initialState = {
  organization: null,
  loading: false,
  error: null,
};

const organizationCreateReducer = (state = initialState, {
  type, error,
}) => {
  switch (type) {
    case CREATE_ORGANIZATION_REQUEST:
      return { ...state, loading: true };
    case CREATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_ORGANIZATION_FAILED:
      return {
        ...state, loading: false, error,
      };
    default:
      return state;
  }
};

export default organizationCreateReducer;
